export default {
  callHistory: []
}
